export default {
  method_unavailable: 'Ta metoda płatności jest teraz niedostępna. Wybierz inną.',
  payment_option_unavailable: 'Ta opcja płatności jest teraz niedostępna. Wybierz inny sposób płatności.',
  online_payment_unavailable: 'Płatność online jest teraz niedostępna. Spróbuj ponownie za chwilę.',
  retry_payment_methods: 'Spróbuj ponownie',
  payment_not_ready: 'Twoja płatność jest jeszcze przygotowywana. Spróbuj ponownie za chwilę.',
  wallet_total_changed: 'Suma dla tej metody płatności uległa zmianie. Sprawdź ją i kliknij przycisk ponownie.',
  wallet_tap_above: 'Kliknij przycisk {{method}} powyżej, aby zapłacić, lub wybierz inny sposób płatności.',
  wallet_pay_above: 'Użyj przycisku {{method}} powyżej',
  element_incomplete: 'Uzupełnij dane płatności, aby kontynuować.',
  element_incomplete_card: 'Sprawdź dane karty i spróbuj ponownie.',
  element_incomplete_bank: 'Wybierz swój bank, aby kontynuować.',
  element_incomplete_sepa_debit: 'Sprawdź swój IBAN i dane właściciela konta, aby kontynuować.',
};
